// Small text utilities shared by core and UI.

/**
 * Clean up small generation artifacts (doubled words, space-before-punctuation,
 * run-on spaces) that the fast model occasionally emits. Deliberately
 * conservative: only collapses whitespace-separated repeats, so sentence
 * boundaries ("...latency. Latency...") and code are untouched.
 */
export function tidyProse(s: string | null | undefined): string {
  return (s || "")
    .replace(/\b(\w+)(\s+\1\b)+/gi, "$1")
    .replace(/\s+([,.;:!?])/g, "$1")
    .replace(/[ \t]{2,}/g, " ")
    .trim();
}

export function truncate(s: string, n: number): string {
  return s.length > n ? s.slice(0, n - 1) + "…" : s;
}

export function clamp(x: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, x));
}

export function timeAgo(ts: number): string {
  const s = Math.max(1, Math.round((Date.now() - ts) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
}
